import * as Mousetrap from 'mousetrap';

export class ShortcutManager {
  private static _instance: ShortcutManager;

  public static getInstance(): ShortcutManager {
    if (!ShortcutManager._instance) {
      ShortcutManager._instance = new ShortcutManager();
    }
    return ShortcutManager._instance;
  }

  private shortcutMappings: {
    [keys: string]: {
      group: string;
      title: string;
      callback: () => void;
    };
  };
  private groups: { [group: string]: { title: string; keys: string }[] };

  constructor() {
    this.shortcutMappings = {};
    this.groups = {};
  }

  public registerShortcut(keys: string, callback: () => void, group: string, title: string) {
    if (this.shortcutMappings[keys]) {
      return;
    }
    Mousetrap.bind(keys, callback);
    this.shortcutMappings[keys] = { group, title, callback };
    if (!this.groups[group]) {
      this.groups[group] = [];
    }
    this.groups[group].push({ title, keys });
  }

  public unregisterShortcut(keys: string) {
    Mousetrap.unbind(keys);

    const mapping = this.shortcutMappings[keys];
    this.groups[mapping.group] = this.groups[mapping.group].filter((s) => s.keys !== keys);
    delete this.shortcutMappings[keys];
  }

  public getRegistrations(): { [group: string]: { title: string; keys: string }[] } {
    return this.groups;
  }

  public reset(): void {
    Mousetrap.reset();
    this.shortcutMappings = {};
    this.groups = {};
  }
}
